import styled, { css } from 'react-emotion';

import { queries } from './mediaQueries';
import theme from './theme';

const Container = styled.section`
	width: 100%;
	height: 100vh;
`;

export const resultsContainer = css`
	width: calc(100% - ${theme.grid.leftAreaWidth});

	${queries.xLarge`
		width: 100%;
	`};
`;

export const textSearchContainer = css`
	position: fixed;
	z-index: 3;
	${resultsContainer};

	.search-input {
		height: ${theme.grid.textSearchHeight};
		border: none;
		border-bottom: 1px solid #ccc;
		background: #fafafa;
		transition: all 0.3s cubic-bezier(.25,.8,.25,1);

		&:focus {
			border-color: ${theme.colors.primaryColor};
			box-shadow: 0 1px 0 0 ${theme.colors.primaryColor};
		}
	}

	${queries.xLarge`
		margin-top: ${theme.grid.topXLargeMargin};
		width: calc(100% - 280px);
		right: 0px;

		.search-input {
			height: ${theme.grid.topXLargeTextSearchHeight};

			&:focus {
				border-bottom: 1px solid #ccc;
				box-shadow: none;
			}
		}


	`};
	${queries.medium`
		margin-top: 60px;
		width: auto;
		left: 0px;
		margin-right: ${theme.grid.topXLargeMarginSides};
		margin-left: ${theme.grid.topXLargeMarginSides};

		.search-input {
		    width: 100%;
		    border-radius: 5px;
		    box-shadow: 2px 2px 3px black;
		}
	`};
`;

export const selectedFiltersContainer = css`
    position: fixed;
    ${resultsContainer};
    margin-top: ${theme.grid.textSearchHeight};
    margin-bottom: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    height: ${theme.grid.textSearchHeight};
    padding-left: 12px;
    display: flex;
    align-items: center;
    text-align: right;
`;

export const searchFiltersContainer = css`
	max-height: calc(100vh - 100px);
	overflow-y: auto;
	height: 100%;
`;

export const appContainer = css`
	${queries.xLarge`
		flex-direction: column;
	`};
`;

export default Container;



// WEBPACK FOOTER //
// ./src/styles/Container.js